module.exports = __webpack_public_path__ + "img/upcoming-fixtures-3.8cd7ac99.svg";